import {
  PickerForm,
  PickerBlock,
  HorizontalWrapper,
  PickerWrapper,
  Field,
  Button,
  Label,
  TimeslotLabelWrapper,
  Timeslot,
  Decorator
} from './styles'

PickerForm.PickerBlock = PickerBlock
PickerForm.HorizontalWrapper = HorizontalWrapper
PickerForm.Field = Field
PickerForm.Button = Button
PickerForm.Label = Label
PickerForm.PickerWrapper = PickerWrapper
PickerForm.TimeslotLabelWrapper = TimeslotLabelWrapper
PickerForm.Timeslot = Timeslot
PickerForm.Decorator = Decorator

export default PickerForm
